// deploy
export const ApiUrl = `${process.env.REACT_APP_API_URL}/api`;

// local
// export const ApiUrl = `${process.env.REACT_APP_API_URL_LOCAL}/api`;
